<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑小度参数</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="max-height: 400px">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">名称</div>
            <el-input v-model="editForm.name" disabled></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">项目ID</div>
            <el-input v-model="editForm.shopId"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">项目的呼叫中心号码</div>
            <el-input v-model="editForm.phone"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">项目的呼叫中心号码挂载的uid</div>
            <el-input v-model="editForm.uid"></el-input>
          </el-col>
          <el-col :span="24" class="item">
            <div class="label">服务授权的appId</div>
            <el-input v-model="editForm.appId"></el-input>
          </el-col>
          <el-col :span="24" class="item">
            <div class="label">服务授权的appSecret</div>
            <el-input v-model="editForm.appSecret"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">呼叫中心号码相关的appId</div>
            <el-input v-model="editForm.rtcAppId"></el-input>
          </el-col>
          <el-col :span="24" class="item">
            <div class="label">呼叫中心号码相关的appSecret</div>
            <el-input v-model="editForm.rtcAppSecret"></el-input>
          </el-col>

        </el-row>


      </div>

      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm()">保存</el-button>
      </div>

    </div>


  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props:['roleValue'],
  data() {
    return {

      loading: false,

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        governmentCode:'',
        name:'',

        shopId:'',
        appId:'',
        appSecret:'',
        rtcAppId:'',
        rtcAppSecret:'',
        phone:'',
        uid:'',

      },


    }
  },
  components: {

  },

  methods: {
    init(row){

      this.editForm.governmentCode = row.governmentCode;
      this.editForm.name = row.name;

      this.editForm.shopId = '';
      this.editForm.appId = '';
      this.editForm.appSecret = '';
      this.editForm.rtcAppId = '';
      this.editForm.rtcAppSecret = '';
      this.editForm.phone = '';
      this.editForm.uid = '';

      this.getInfo(row.governmentCode);

    },
    closeSelf() {
      this.$emit("closeEditXDu");
    },

    getInfo(governmentCode){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"GovernmentXDuRel/InfoByGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode: governmentCode,
        }
      }).then((response) => {
            if (response.data.error == 0) {

              let governmentXDuRel = response.data.data.governmentXDuRel;

              if(governmentXDuRel != null){
                this.editForm.shopId = governmentXDuRel.shopId;
                this.editForm.appId = governmentXDuRel.appId;
                this.editForm.appSecret = governmentXDuRel.appSecret;
                this.editForm.rtcAppId = governmentXDuRel.rtcAppId;
                this.editForm.rtcAppSecret = governmentXDuRel.rtcAppSecret;
                this.editForm.phone = governmentXDuRel.phone;
                this.editForm.uid = governmentXDuRel.uid;
              }

            }else {
              this.$message({type: 'info', message: '获取失败'});
            }
          }
      )
    },

    confirm(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"GovernmentXDuRel/GovEdit",
        data: this.editForm
      }).then((response) => {
            this.loading = false;

            if (response.data.error == 0) {
              this.$emit("closeEditXDu");
              this.$message({type: 'success', message: '编辑成功'});

            }else {
              this.$message({type: 'info', message: '编辑失败'});
            }
          }
      )

    },



  }
}


</script>


<style lang="scss" scoped>


</style>
